import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UIControlService {
  private successDuration = 5000;
  private failureDuration = 5000;

  public sideNavOpen$ = new BehaviorSubject<boolean>(false);

  constructor(private snackbar: MatSnackBar) {}

  public notifySuccess(message: string, confirm = 'Ok') {
    this.snackbar.open(message, confirm, { duration: this.successDuration });
  }
  public notifyFailure(message: string, confirm = 'Ok') {
    this.snackbar.open(message, confirm, {
      duration: this.failureDuration,
      panelClass: ['error-snackbar']
    });
  }
}
